import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';

const AUTH_BACKGROUNDS = [
	'/auth/backgrounds/bg-1.jpg',
	'/auth/backgrounds/bg-2.jpg',
	'/auth/backgrounds/bg-3.jpg',
	'/auth/backgrounds/bg-4.jpg',
	'/auth/backgrounds/bg-5.jpg',
	'/auth/backgrounds/bg-6.jpg',
	'/auth/backgrounds/bg-7.jpg',
	'/auth/backgrounds/bg-8.jpg'
];

const ROTATE_MS = 8000;

function AuthPageLayout({ mode, history, children }) {
	const [activeIndex, setActiveIndex] = useState(0);
	const isSignIn = mode === 'signin';

	useEffect(() => {
		document.body.classList.remove('has-navbar-fixed-top');

		return () => {
			if (!document.body.classList.contains('has-navbar-fixed-top')) {
				document.body.classList.add('has-navbar-fixed-top');
			}
		};
	}, []);

	useEffect(() => {
		const id = setInterval(() => {
			setActiveIndex(index => (index + 1) % AUTH_BACKGROUNDS.length);
		}, ROTATE_MS);
		return () => clearInterval(id);
	}, []);

	const linkState = history.location.state?.apply
		? { apply: history.location.state.apply }
		: null;

	return (
		<div className={`auth-page auth-page--${mode}`}>
			<aside className="auth-page__visual" aria-hidden="true">
				<div className="auth-page__slides">
					{AUTH_BACKGROUNDS.map((src, index) => (
						<div
							key={src}
							className={`auth-page__slide${
								index === activeIndex ? ' is-active' : ''
							}`}
							style={{ backgroundImage: `url(${src})` }}
						/>
					))}
				</div>
				<div className="auth-page__brand">
					<img
						className="auth-page__logo"
						src="/auth/prediktive-mira-logo.svg"
						alt="Prediktive | Mira"
					/>
					<p className="auth-page__tagline">Find fast. Hire right.</p>
				</div>
			</aside>

			<main className="auth-page__panel">
				<div className="auth-page__panel-inner">
					<h1 className="auth-page__title">Welcome to Mira</h1>

					<div
						className="auth-page__toggle"
						role="tablist"
						aria-label="Authentication mode">
						<Link
							role="tab"
							aria-selected={!isSignIn}
							className={`auth-page__toggle-option${!isSignIn ? ' is-active' : ''}`}
							to={{
								pathname: '/signup',
								search: history.location.search,
								state: linkState
							}}>
							Sign Up
						</Link>
						<Link
							role="tab"
							aria-selected={isSignIn}
							className={`auth-page__toggle-option${isSignIn ? ' is-active' : ''}`}
							to={{
								pathname: '/login',
								search: history.location.search,
								state: linkState
							}}>
							Sign In
						</Link>
					</div>

					{children}
				</div>
			</main>
		</div>
	);
}

export default withRouter(AuthPageLayout);
